import { fetchAuthSession, getCurrentUser, signOut, signIn, fetchUserAttributes } from 'aws-amplify/auth'
import NetInfo from '@react-native-community/netinfo'
import Constants from 'expo-constants'
import * as SecureStore from 'expo-secure-store'
import SecureStoreWeb from './SecureStoreWeb'
import { UserServices } from '../../database/user.database'
import {
    documentDirectory,
    cacheDirectory,
    StorageAccessFramework,
    EncodingType,
    downloadAsync,
    getInfoAsync,
    deleteAsync,
    makeDirectoryAsync,
    readAsStringAsync,
    writeAsStringAsync,
    copyAsync,
    getFreeDiskStorageAsync,
    readDirectoryAsync,
} from './fileSystemCompat'
import { shareAsync } from 'expo-sharing'
import { Alert, Linking } from 'react-native'
import * as Device from 'expo-device'
import { getAppVersion, getPrefix } from '../components/customUtils/AppConstants'
import { getPlatform } from './platformUtils'
import { useState } from 'react'
import { EventEmitter } from 'events'
import { activateKeepAwakeAsync, deactivateKeepAwake } from 'expo-keep-awake'
import * as LocalAuthentication from 'expo-local-authentication'
import JSZip from 'jszip'
import { ErrorServices } from '../../database/errors.database'
import { schedulesServices } from '../../database/schedules.database'
import { PROGRESS_STEPS } from '../redux/zustand/progressScheduleStore'
import { SCHEDULES_STORE_NAMES } from '../db/constants'
import { FORM_SCHEDULE_STATUS } from '../components/stores/constants/constants.stores'
import { apiUrl, TEST } from '../config/config'
import { manipulateAsync } from 'expo-image-manipulator'
import { CLIENTS_SLUGS } from '../constants/slugs'

const expoConfig = Constants.expoConfig
const slug = expoConfig.slug || ''

export const eventEmitter = new EventEmitter()

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export const verify_user_cognito = async () => {
    // Evitar tocar Identity Pool sin sesión y reducir spam de errores
    const netInfoState = await NetInfo.fetch()
    // Loggear a lo sumo cada 120s cuando no hay sesión
    const staticState: any = verify_user_cognito as any
    staticState._lastNoSessionLog = staticState._lastNoSessionLog || 0

    if (netInfoState.isConnected && netInfoState.isInternetReachable) {
        try {
            // Validar primero si hay usuario actual (no toca identidad si no hay sesión)
            await getCurrentUser()
            let attempts = 0
            const maxAttempts = 5 // Número máximo de intentos

            while (attempts < maxAttempts) {
                try {
                    const attributes = await fetchUserAttributes()
                    console.log('Atributos del usuario: ', attributes.length)
                    break // Éxito
                } catch (err: any) {
                    if (err?.code === 'TooManyRequestsException') {
                        attempts++
                        console.log(`Intento ${attempts} fallido debido a exceso de tasa. Reintentando...`)
                        await delay(1000 * attempts)
                    } else {
                        // Otros errores: salir sin derribar sesión
                        throw err
                    }
                }
            }

            if (attempts === maxAttempts) {
                console.error('Se ha alcanzado el máximo de intentos para obtener los atributos.')
            }
        } catch (err: any) {
            // Sin sesión o error distinto: no insistir ni forzar logout
            const now = Date.now()
            if (now - staticState._lastNoSessionLog > 120000) {
                console.error('Error en la verificación del usuario:', err)
                staticState._lastNoSessionLog = now
            }
            if (err?.message && String(err.message).includes('User is disabled')) {
                console.log('El usuario está deshabilitado. Deslogueando...')
                await signOut()
            } else {
                // Mantener UX estable
                console.log('Error inesperado, el usuario puede continuar en la app:', err?.message || String(err))
            }
        }
    } else {
        console.log('No tiene conexión, no se puede validar al usuario en este momento.')
    }
}

/**
 *
 * @param directory carpeta donde guardar, ej: /stores/form
 * @returns directorio donde se guarda la imagen ej: dots/contents/stores/form/1721050656367.jpg
 */
export const get_url_save_photo = (directory: string) => {
    const timestamp = Date.now()

    return `${Constants.expoConfig.slug}/contents${directory}/${timestamp}.jpg`
    // try {
    //     let save_directory
    //     const get_user_profile = await UserServices.getUser()

    //     if (get_user_profile && get_user_profile.url_uploads) {
    //         save_directory = get_user_profile.url_uploads.slice(1) + directory + `/${timestamp}.jpg`

    //         return save_directory
    //     } else {
    //         return `${Constants.expoConfig.slug}/contents${directory}/${timestamp}.jpg`
    //     }

    // } catch (error) {
    //     return `${Constants.expoConfig.slug}/contents${directory}/${timestamp}.jpg`
    // }
}

export const downloadPdf = async (downloadLink: string) => {
    eventEmitter.emit('start')
    try {
        let url = downloadLink
        if (downloadLink.includes('drive')) {
            url = downloadLink.split('url=').pop()
        }

        const fileName = url.split('/').pop()
        const platformOS = getPlatform().OS
        const downloadDir = platformOS === 'ios' ? cacheDirectory : documentDirectory
        const fileUri = `${downloadDir}${fileName}`
        const result = await downloadAsync(url, fileUri)
        // console.log("result", result)

        if (platformOS === 'android') {
            const permissions = await StorageAccessFramework.requestDirectoryPermissionsAsync()
            if (permissions.granted) {
                const base64 = await readAsStringAsync(result.uri, { encoding: 'base64' })
                await StorageAccessFramework.createFileAsync(permissions.directoryUri, fileName, result.headers['Content-Type'])
                    .then(async (res) => {
                        await writeAsStringAsync(res, base64, { encoding: 'base64' })
                        shareAsync(res)
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                shareAsync(result.uri)
            }
        } else {
            shareAsync(result.uri)
        }
    } catch (error) {
        console.error('Error downloading file', error)
    } finally {
        eventEmitter.emit('end')
    }
}

export const getDeviceInfo = () => {
    return {
        model: Device.modelName,
        name: Device.osName,
        system: Device.osVersion,
        platform: getPlatform().OS,
        brand: Device.brand,
        app_version: getAppVersion(),
    }
}

const withTimeout = (promise, ms) => {
    const timeout = new Promise((_, reject) => setTimeout(() => reject(new Error('Request timed out')), ms))
    return Promise.race([promise, timeout])
}

export const downloadAndUnzip = async (name: string, url: string, setProgress: (number) => void | null) => {
    console.log('157 --- 🚀 ~ downloadAndUnzip ~ setProgress:', setProgress)

    if (setProgress && name == 'stores') {
        setProgress(PROGRESS_STEPS.STEP_2.start)
    }
    if (setProgress && name == 'schedule_stores') {
        setProgress(PROGRESS_STEPS.STEP_5.start)
    }

    let serviceFileName = url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('.zip'))
    console.log('File', serviceFileName)
    if (!serviceFileName || serviceFileName === '') {
        serviceFileName = name
    }

    const directoryUri = `${documentDirectory}zip/${name}/`
    const fileUri = `${directoryUri}${serviceFileName}.zip`

    try {
        // Descargar el archivo ZIP
        const dirInfo = await getInfoAsync(directoryUri)

        if (!dirInfo.exists) {
            // si no existe el directorio, lo creamos
            await makeDirectoryAsync(directoryUri, { intermediates: true })
            console.log('Directorio creado:', directoryUri)
        }

        // verifico si existe el archivo zip y lo elimino
        await verifyAndDeleteZip(fileUri)
        console.log('Estoy en el paso de verificación 165')

        // Descargar el archivo ZIP con timeout
        const { uri } = await withTimeout(downloadAsync(url, fileUri), 600000) // Timeout de 10 minutos
        console.log('Archivo descargado en:', uri)

        // setProgress(PROGRESS_STEPS.STEP_2.end)
        if (setProgress && name == 'stores') {
            setProgress(PROGRESS_STEPS.STEP_3.start)
        }

        if (setProgress && name == 'schedule_stores') {
            setProgress(PROGRESS_STEPS.STEP_6.start)
        }

        const fileContents = await readAsStringAsync(uri, {
            encoding: 'base64',
        })

        const zip = new JSZip()
        const content = await zip.loadAsync(fileContents, { base64: true })

        let targetPath = null

        for (let filename of Object.keys(content.files)) {
            if (filename.startsWith('__MACOSX/') || filename.includes('.DS_Store')) continue

            const file = content.files[filename]
            if (!file.dir) {
                const fileData = await file.async('base64')
                targetPath = `${documentDirectory}unzipped/${name}/${filename}`
                const dirPath = `${documentDirectory}unzipped/${name}`

                await makeDirectoryAsync(dirPath, { intermediates: true })
                await writeAsStringAsync(targetPath, fileData, {
                    encoding: 'base64',
                })
                console.log('Archivo descomprimido en:', targetPath)
            }
        }

        if (setProgress && name == 'stores') {
            setProgress(PROGRESS_STEPS.STEP_3.end)
        }
        if (setProgress && name == 'schedule_stores') {
            setProgress(PROGRESS_STEPS.STEP_6.end)
        }

        return targetPath
    } catch (error) {
        console.error('Error en downloadAndUnzip:', error)
        return null
    }
}

/**
 * @description extrae todos los archivos de un .zip y los guarda dentro de /unzipped
 * @param name nombre de la carpeta donde se va a guardar el .zip
 * @param url url a descargar y descomprimir
 * @returns
 */
export const downloadAndUnzipAllFiles = async (name: string, url: string, urlFailedDownload?: { [key: string]: string }[]) => {
    // console.log('220 --- 🚀 ~ downloadAndUnzipAllFiles ~ urlFailedDownload:', JSON.stringify(urlFailedDownload))
    // tomar lo de adentro de la carpeta padre

    const directoryUri = name && name != '' ? `${documentDirectory}zip/${name}/` : `${documentDirectory}zip/`

    const fileUri = `${directoryUri}downloaded.zip`

    const pathDownloaded = name && name != '' ? `${documentDirectory}unzipped/${name}/` : `${documentDirectory}unzipped/`

    try {
        // Descargar el archivo ZIP
        const dirInfo = await getInfoAsync(directoryUri)

        if (!dirInfo.exists) {
            // si no existe el directorio, lo creamos
            await makeDirectoryAsync(directoryUri, { intermediates: true })
            console.log('Directorio creado:', directoryUri)
        }

        // Verifico si existe el archivo zip y lo elimino
        await verifyAndDeleteZip(fileUri)

        const { uri } = await downloadAsync(url, fileUri)
        // console.log('241 --- 🚀 ~ downloadAndUnzipAllFiles ~ uri:', uri)

        // Leer el contenido del archivo ZIP como binario
        const fileContents = await readAsStringAsync(uri, {
            encoding: 'base64',
        })

        // console.log('248 ---- ')

        // Cargar el archivo ZIP en JSZip
        const zip = new JSZip()
        const content = await zip.loadAsync(fileContents, { base64: true })
        let targetPath = null

        let fileNameFather = url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('.zip'))
        console.log('fileNameFather =====>', fileNameFather)
        // para sacar el 00_iddelcurso
        if (fileNameFather.includes('_')) {
            const fileNameFatherSplit = fileNameFather.split('_')
            fileNameFather = fileNameFatherSplit[1]
        }

        // Extraer archivos a la carpeta de destino
        for (let filename of Object.keys(content.files)) {
            // Filtrar archivos __MACOSX. Metadatos que macOS incluye en los archivos ZIP
            if (filename.startsWith('__MACOSX/')) {
                continue
            }

            // sacar el nombre del archivo padre
            const relativePath = filename.replace(`${fileNameFather}/`, '')

            let file = content.files[filename]
            // console.log("============================>>>>>>>>>>>>>>> File", relativePath);
            if (!file.dir) {
                let fileData = await file.async('base64')
                targetPath = `${pathDownloaded}${relativePath}`
                console.log('este es mi path ======>>>>>', targetPath)

                // Crear directorio de destino si es necesario
                const targetDir = targetPath.substring(0, targetPath.lastIndexOf('/'))
                await makeDirectoryAsync(targetDir, { intermediates: true })

                // Escribir el archivo descomprimido en el sistema de archivos
                await writeAsStringAsync(targetPath, fileData, {
                    encoding: 'base64',
                })
            }
        }

        console.log('Descompresión completada en:', pathDownloaded)
        return pathDownloaded
    } catch (error) {
        if (error.message && error.message.includes('OutOfMemoryError')) {
            if (urlFailedDownload && urlFailedDownload.length > 0) {
                // descargo todo lo de esta url
                const directoryUri = `${documentDirectory}unzipped/`
                for (const item of urlFailedDownload) {
                    const [key, url] = Object.entries(item)[0]
                    console.log(`Intentando descargar el archivo ${key} desde la URL de respaldo...: ${url}`)

                    if (key === 'assets' && Array.isArray(url)) {
                        const total = url.length
                        let descargados = 0
                        let errorDescargados = []
                        let errorDescargadosCount = 0

                        console.log(`Total de archivos a descargar: ${total}`)

                        for (const assetUrl of url) {
                            if (!assetUrl || assetUrl === '') {
                                console.error(`URL de respaldo no válida para ${key}.`)
                                continue
                            }
                            const fileName = getNameUrl(assetUrl)

                            const fileUri = `${directoryUri}${fileName}`

                            try {
                                const { uri } = await downloadAsync(assetUrl, fileUri)

                                descargados++

                                // console.log(`Archivo ${fileName} descargado en: ${uri}`)
                                // console.log(`====> Archivo ${fileName} descargado. (${descargados}/${total})`)
                            } catch (error) {
                                errorDescargados.push(assetUrl)
                                errorDescargadosCount++
                                console.error(`22Error al descargar ${fileName} desde la URL de respaldo:`, error)
                            }
                        }
                    } else {
                        if (!url || url === '') {
                            console.error(`URL de respaldo no válida para ${key}.`)
                            continue
                        }
                        const fileUri = `${directoryUri}${key}.json`

                        try {
                            const { uri } = await downloadAsync(url, fileUri)
                        } catch (error) {
                            console.error(`1Error al descargar ${key}.json desde la URL de respaldo:`, error)
                        }
                    }
                }
                return directoryUri
            } else {
                console.error('No se proporcionó una URL de respaldo para descargar el archivo.: ', error)
            }
        } else {
            console.error('Error al descomprimir el archivo:', error)
        }
        return null
    }
}

export const getNameUrl = (url: string) => {
    const parts = url.split('/')
    const lastPart = parts.pop()
    if (lastPart) {
        return lastPart.split('?')[0]
    }
    return null
}

export const readAndParseJSON = async (filePath) => {
    try {
        // Leer el contenido del archivo JSON
        const jsonContent = await readAsStringAsync(filePath)
        const parsedData = JSON.parse(jsonContent)

        console.log('Contenido del JSON leído y parseado con éxito.')
        return parsedData
    } catch (error) {
        console.error('Error al descargar o leer el archivo JSON:', error)
        return null
    }
}

export const deleteZipFolder = async (path = null) => {
    try {
        if (path && path !== '') {
            await deleteAsync(path, { idempotent: true })
            // console.log('Directorio eliminado:', path)
            return
        }

        const directoryUri = `${documentDirectory}zip/`
        const unzzipedDirectory = `${documentDirectory}unzipped/`

        await deleteAsync(directoryUri, { idempotent: true })
        // console.log('Directorio eliminado:', directoryUri)

        await deleteAsync(unzzipedDirectory, { idempotent: true })
        // console.log('Directorio eliminado:', unzzipedDirectory)
    } catch (error) {
        console.error('Error al eliminar el directorio:', error)
    }
}

export const verifyAndDeleteZip = async (path: string) => {
    try {
        const fileInfo = await getInfoAsync(path)

        if (fileInfo.exists) {
            await deleteAsync(path, { idempotent: true })
            console.log('verifyAndDeleteZip - Archivo eliminado:', path)
        } else {
            console.log('verifyAndDeleteZip - El archivo no existe:', path)
        }
    } catch (error) {
        console.error('verifyAndDeleteZip - Error al eliminar el directorio:', error)
    }
}

let __NET_LOG_LAST = 0

/**
 * Elimina archivos locales no referenciados dentro de documentDirectory/unzipped/<path>/
 * Mantiene los archivos cuyos nombres se derivan de las URLs referenciadas (considera también variante .webp).
 */
export const pruneDownloadedContent = async (path: string, referencedUrls: string[]) => {
    try {
        if (!path || path.trim() === '') return
        const directoryUri = `${documentDirectory}unzipped/${path}/`
        const dirInfo = await getInfoAsync(directoryUri)
        if (!dirInfo.exists) return

        // Construir set de nombres permitidos (incluye variante .webp para jpg/png/jpeg)
        const allowed = new Set<string>()
        for (const url of referencedUrls || []) {
            if (!url) continue
            const name = getNameUrl(url)
            if (name) {
                allowed.add(name)
                const lower = name.toLowerCase()
                if (lower.endsWith('.jpg') || lower.endsWith('.jpeg') || lower.endsWith('.png')) {
                    // agregar variante .webp que puede existir localmente
                    const base = name.replace(/\.(jpg|jpeg|png)$/i, '')
                    allowed.add(`${base}.webp`)
                }
            }
        }

        const entries = await readDirectoryAsync(directoryUri)
        if (!Array.isArray(entries)) return

        let deleted = 0
        for (const entry of entries) {
            const keep = allowed.has(entry)
            if (!keep) {
                try {
                    await deleteAsync(`${directoryUri}${entry}`, { idempotent: true })
                    deleted++
                    if (deleted % 20 === 0) {
                        console.log(`pruneDownloadedContent[${path}]: eliminados ${deleted} archivos...`)
                    }
                } catch (e) {
                    console.warn('pruneDownloadedContent: no se pudo eliminar', entry, (e as any)?.message)
                }
            }
        }
        if (deleted > 0) console.log(`pruneDownloadedContent[${path}] completo. Eliminados: ${deleted}`)
    } catch (e) {
        console.warn('pruneDownloadedContent error:', (e as any)?.message)
    }
}
const ENABLE_NET_LOGS = false // activar solo para debug fino
export const validateConnectionNetwork = async (type_send = false) => {
    const now = Date.now()
    if (ENABLE_NET_LOGS && now - __NET_LOG_LAST > 60000) {
        console.log('� validateConnectionNetwork - Starting with type_send:', type_send)
        __NET_LOG_LAST = now
    }
    // TEMPORAL FIX: Bypass NetInfo issues in web and iOS
    if (getPlatform().OS === 'web' || getPlatform().OS === 'ios') {
        if (ENABLE_NET_LOGS) console.log('BYPASS validateConnectionNetwork for', getPlatform().OS)
        return true
    }
    try {
        // https://github.com/react-native-netinfo/react-native-netinfo
        const netInfo = await NetInfo.fetch()
        const { isConnected, isInternetReachable, type, details } = netInfo

        if (ENABLE_NET_LOGS)
            console.log('� NetInfo raw result:', {
                isConnected,
                isInternetReachable,
                type,
                details,
                fullNetInfo: netInfo,
            })

        if (!isConnected) {
            console.log('❌ validateConnectionNetwork - isConnected is false')
            return false
        }

        if (typeof isInternetReachable === 'boolean' && !isInternetReachable) {
            console.log('❌ validateConnectionNetwork - isInternetReachable is false')
            return false
        }

        if (!type_send) {
            if (type === 'unknown') {
                if (ENABLE_NET_LOGS) console.log('❌ validateConnectionNetwork - type is unknown')
                return false
            }

            if (type === 'cellular') {
                if (details && details.cellularGeneration) {
                    const { cellularGeneration } = details
                    if (cellularGeneration === '2g' || cellularGeneration === '3g') {
                        if (ENABLE_NET_LOGS) console.log('❌ validateConnectionNetwork - cellular generation too slow:', cellularGeneration)
                        return false
                    }
                }
            }
        }

        if (ENABLE_NET_LOGS) console.log('✅ validateConnectionNetwork - All checks passed, returning true')
        return true
    } catch (error) {
        if (ENABLE_NET_LOGS) console.error('❌ validateConnectionNetwork - Exception caught:', error)
        if (ENABLE_NET_LOGS)
            console.error('❌ validateConnectionNetwork - Error details:', {
                name: error.name,
                message: error.message,
                stack: error.stack,
            })
        return false
    }
}

export const getCountRegisterByUrl = (url: string) => {
    const match = url.match(/json_(\d+)/)

    if (match) return match[1]

    return null
}

/**
 * @description extrae version de la url (fecha y hora)
 * @param url location
 * @returns dd-mm-yyyy-hh-mm - 06-11-2024-02-12 (dia/mes/año/hora/minutos)
 */
export const getVersionByURL = (url: string): string => {
    if (!url || url === '') {
        console.log('URL no válida.')
        return null
    }
    const regex = /(\d{2}-\d{2}-\d{4}-\d{2}-\d{2})\.zip$/

    const match = url.match(regex)

    if (match) {
        const dateTime = match[1]
        console.log('Fecha y hora extraídas:', dateTime)

        return dateTime
    } else {
        console.log('No se encontró una fecha y hora en la URL.')
        return null
    }
}

/**
 *
 * @description extrae la version de una url con formato https://resources-one.s3.us-east-2.amazonaws.com/dots/contents/courses/00_64b5933f62fe0d00085c4b7d.zip
 * @param url URL del curso a descargar
 * @returns <String> string
 */
export const getVersionLearningByURL = (url: string): number => {
    if (!url || url === '') {
        console.log('URL no válida.')
        return null
    }

    const regex = /\/courses\/(\d{2})_/
    const match = url.match(regex)
    return match ? parseInt(match[1]) : null
}

/**
 * @description extrae el id de la url
 * @param url URL del contenido
 * @returns <String> string
 */
export const getIdByURL = (url: string): string => {
    if (!url || url === '') {
        console.log('URL no válida.')
        return ''
    }

    const id = url.split('/').pop().split('_')[0]

    return id ?? ''
}
export function isValidUrl(url: string): boolean {
    try {
        if (!url || typeof url !== 'string') {
            return false
        }

        const cleanUrl = url.trim().replace(/^["']|["']$/g, '') // Eliminar comillas del inicio/fin

        if (cleanUrl === 'null' || cleanUrl === 'undefined' || cleanUrl === '') {
            console.log('isValidUrl - URL is null/undefined/empty string')
            return false
        }

        new URL(cleanUrl)
        return true

    } catch (error) {
        return false
    }
}
export const downloadContent = async (
    path: string,
    urls: string[],
    size = 10,
    setProgressFn = null,
    isDownloadAssets = false,
    setModalErrorDownloadAsset = null,
) => {
    if (!urls || !path || path == '') {
        return null
    }

    let contentArray = []

    for (const url of urls) {
        if (url && isValidUrl(url)) {
            contentArray.push(url)
        } else {
            console.error('URL no válida.')
        }
    }
    if (contentArray.length === 0) {
        console.error('No hay contenido para descargar.')
        return null
    }

    try {
        const directoryUri = `${documentDirectory}unzipped/${path}/`
        const dirInfo = await getInfoAsync(directoryUri)

        if (!dirInfo.exists) {
            await makeDirectoryAsync(directoryUri, { intermediates: true })
            console.log('Directorio creado:', directoryUri)
        }
        const total = urls.length
        let descargados = 0
        let errorDescargados = []
        let errorDescargadosCount = 0
        const statusComplete = 1
        let countRenderModal = 0

        const downloadBatch = async (batch: string[]) => {
            const promises = batch.map(async (content) => {
                const contentName = getNameUrl(content)
                if (!contentName || contentName === '') {
                    return
                }
                const fileUri = `${directoryUri}${contentName}`
                try {
                    // Si ya existe un archivo válido, no re-descargar
                    try {
                        const info = await getInfoAsync(fileUri)
                        if (info?.exists && (typeof info?.size !== 'number' || info.size > 0)) {
                            // ya lo contamos como disponible
                            descargados++
                            return
                        }
                    } catch {}

                    await downloadAsyncFS(content, fileUri)
                    descargados++

                    if (descargados % 10 === 0) {
                        // console.log(`====> Archivo ${contentName} descargado. (${descargados}/${total})`)
                    }
                } catch (error) {
                    errorDescargados.push(content)
                    errorDescargadosCount++
                    countRenderModal++

                    if (
                        isDownloadAssets &&
                        error.message &&
                        error.message.includes('No address associated with hostname') &&
                        countRenderModal === 1
                    ) {
                        console.log('554 ----- No se encontró el archivo:', contentName)
                        setModalErrorDownloadAsset()
                        throw new Error(error)
                    }
                }
            })
            // await ejecutarSecuencialmente(promises)
            await Promise.allSettled(promises)
        }

        if (contentArray.length > size) {
            // console.log('537 -- descargo por batches')
            for (let i = 0; i < contentArray.length; i += size) {
                const batch = contentArray.slice(i, i + size)
                await downloadBatch(batch)
                if (setProgressFn != null) {
                    const progressFloat = (i + size) / total
                    const progress = Math.trunc(progressFloat * 100)
                    setProgressFn(progress)
                }
            }
        } else {
            // console.log('537 -- descargo normal')
            await downloadBatch(contentArray)
        }

        console.log(`Descarga finalizada. Archivos descargados: ${descargados}/${total}`)

        return {
            total,
            descargados,
            errorDescargadosCount,
            errorDescargados,
        }
    } catch (error) {
        console.error('Error al descargar el contenido:', error)
        throw error
        // return null
    }
}

export const downloadContentPS = async (
    path: string,
    urls: string[],
    size = 10,
    setProgressFn = null,
    isDownloadAssets = false,
    setModalErrorDownloadAsset = null,
) => {
    if (!urls || !path || path == '') {
        return null
    }

    let contentArray = []

    for (const url of urls) {
        if (url && isValidUrl(url)) {
            contentArray.push(url)
        } else {
            console.error('URL no válida.')
        }
    }
    if (contentArray.length === 0) {
        console.error('No hay contenido para descargar.')
        return null
    }

    try {
        const directoryUri = `${documentDirectory}unzipped/${path}/`
        const dirInfo = await getInfoAsync(directoryUri)

        if (!dirInfo.exists) {
            await makeDirectoryAsync(directoryUri, { intermediates: true })
            console.log('Directorio creado:', directoryUri)
        }
        const total = urls.length
        let descargados = 0
        let errorDescargados = []
        let errorDescargadosCount = 0
        const statusComplete = 1
        let countRenderModal = 0
        let onError = null

        const downloadBatch = async (batch: string[]) => {
            for (const content of batch) {
                const contentName = getNameUrl(content)
                if (!contentName || contentName === '') {
                    return
                }
                const fileUri = `${directoryUri}${contentName}`
                try {
                    // Evitar re-descarga si existe un archivo válido
                    try {
                        const info = await getInfoAsync(fileUri)
                        if (info?.exists && (typeof info?.size !== 'number' || info.size > 0)) {
                            descargados++
                            continue
                        }
                    } catch {}
                    await downloadAsyncFS(content, fileUri)
                    descargados++
                    // console.log(`====> Archivo ${contentName} descargado. (${descargados}/${total})`)

                    await schedulesServices.updateStatusLinkAssetsPS(statusComplete, content)
                } catch (error) {
                    errorDescargados.push(content)
                    errorDescargadosCount++
                    countRenderModal++
                    console.error(`Error al descargar ${contentName}: `, error.message)
                    console.error('555 --- Error al descargar el archivo:', JSON.stringify(error))

                    console.log('isDownloadAssets: ', JSON.stringify(isDownloadAssets))
                    console.log('error.message: ', JSON.stringify(error.message))
                    // console.log('error.message.includes: ', JSON.stringify(error.message.includes('No hay conexión a internet')))
                    // console.log('countRenderModal: ', countRenderModal)

                    if (isDownloadAssets && error.message && error.message.includes('No hay conexión a internet')) {
                        console.log('554 ----- No se encontró el archivo:', contentName)

                        setModalErrorDownloadAsset(total, descargados)

                        throw new Error('No hay conexión a internet')
                    }
                }
            }
        }

        if (contentArray.length > size) {
            // console.log('537 -- descargo por batches')
            for (let i = 0; i < contentArray.length; i += size) {
                const batch = contentArray.slice(i, i + size)
                try {
                    await downloadBatch(batch)
                } catch (error) {
                    console.error('downloadBatchdownloadBatchdownloadBatchdownloadBatch', error)
                    break
                }
                if (setProgressFn != null) {
                    const progressFloat = (i + size) / total
                    const progress = Math.trunc(progressFloat * 100)
                    setProgressFn(progress)
                }
            }
        } else {
            // console.log('537 -- descargo normal')
            await downloadBatch(contentArray)
        }

        console.log(`Descarga finalizada. Archivos descargados: ${descargados}/${total}`)

        return {
            total,
            descargados,
            errorDescargadosCount,
            errorDescargados,
        }
    } catch (error) {
        console.error('Error al descargar el contenido:', error)
        throw error
        // return null
    }
}

async function ejecutarSecuencialmente(promise) {
    for (const [index, promiseFn] of promise.entries()) {
        try {
            const resultado = await promiseFn() // Ejecutar la promesa
            console.log(`Promesa ${index + 1} completada:`, resultado)
        } catch (error) {
            console.error(`Error en la promesa ${index + 1}:`, error.message)

            if (error.message === 'Error específico') {
                console.error('Error crítico encontrado. Deteniendo ejecución...')
                break // Detener el bucle si ocurre un error crítico
            }
        }
    }
}

export const deletePathFile = async (path: string) => {
    if (!path || path === '') {
        return
    }
    try {
        await deleteAsync(path, { idempotent: true })
        console.log('Directorio eliminado:', path)
    } catch (error) {
        console.error('Error al eliminar el directorio:', error)
    }
}
export const searchFilebyName = async (fileName: string, path: string) => {
    // Path example :
    // => post => unzipped/post
    // => courses => unzipped/courses/${_idCourse}
    // => stores/portfolio => unzipped/assets

    if (!fileName || fileName === '') {
        return false
    }

    // En web no hay FileSystem nativo: devolvemos false y evitamos getInfoAsync
    try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const { Platform } = require('react-native')
        if (Platform?.OS === 'web') {
            return false
        }
    } catch {}

    // Busco ese corte en cacheDirectory

    //Agregar path por parametro => ej: courses/${_id} courses/672cdf59de9b4c8a2a032289

    const directoryUri = `${documentDirectory}${path}`

    const directoryPath = `${directoryUri}/${fileName}`

    const fileInfo = await getInfoAsync(directoryPath)

    return fileInfo.exists
}

// export const getFilesModifiedYesterday = async (path: string, date: Date) => {
//     try {
//         const directoryUri = `${documentDirectory}${path}`
//         const dirInfo = await readDirectoryAsync(directoryUri)

//         const startOfDay = new Date(date.setHours(0, 0, 0, 0))
//         const endOfDay = new Date(date.setHours(23, 59, 59, 999))

//         const filesModifiedYesterday = []

//         for (const fileName of dirInfo) {
//             const fileUri = `${directoryUri}/${fileName}`
//             const fileInfo = await getInfoAsync(fileUri, { size: true })
//             console.log('File info:', fileInfo)
//             const fileModifiedDate = new Date(fileInfo.modificationTime * 1000)

//             if (fileModifiedDate >= startOfDay && fileModifiedDate <= endOfDay) {
//                 filesModifiedYesterday.push(fileName)
//             }
//         }
//         console.log('Files modified yesterday:', filesModifiedYesterday)
//         return filesModifiedYesterday
//     } catch (error) {
//         console.error('Error al buscar archivos modificados ayer:', error)
//         return []
//     }
// }
export const setKeepAwake = (type: 'active' | 'desactive', tagKeepAwake?: string) => {
    if (type == 'active') {
        activateKeepAwakeAsync(tagKeepAwake)
            .then((res) => {
                // console.log('💚💚 KeepAwake Activado')
            })
            .catch((error) => {
                console.log('Error al activar KeepAwake', error)
            })
    } else {
        deactivateKeepAwake(tagKeepAwake)
            .then((res) => {
                // console.log('💙💙 KeepAwake Desactivado')
            })
            .catch((error) => {
                console.log('Error al desactivar KeepAwake', error)
            })
    }
}

export const getStorageAvailable = async (size?: 'MB' | 'GB') => {
    const storage = await getFreeDiskStorageAsync()
    if (size === 'MB') {
        return converteBytesToMB(storage)
    }
    if (size === 'GB') {
        return convertBytesToGB(storage)
    }
    return storage
}

export const converteBytesToMB = (bytes: number) => {
    if (!bytes) return bytes
    const mb = bytes / (1024 * 1024)
    return mb.toFixed(2)
}

export const convertBytesToGB = (bytes: number) => {
    if (!bytes) return bytes
    const gb = bytes / (1024 * 1024 * 1024)
    return gb.toFixed(2)
}

// Moved to errorUtils.ts to break circular dependency
export { captureAndSaveDataError, type Ierror } from './errorUtils'

// Moved to basicUtils.ts to break circular dependency
export { generateIdDateNow, generateDayUniqueId, getDateNow, isLocalGeneratedId, isValidMongoId, padCodeComplete } from './basicUtils'

export const getDataCountByUrl = (url: string) => {
    if (!url || url === '') {
        console.log('URL no válida.')
        return null
    }
    const regex = /(\d+)_json_(\d+)_(\d+)_(\d+)_/
    const match = url.match(regex)

    if (match) {
        const forms = parseInt(match[2], 10)
        const pos = parseInt(match[3], 10)
        const assets = parseInt(match[4], 10)

        return {
            forms,
            pos,
            assets,
        }
    } else {
        console.error('No se pudieron extraer los valores de la URL proporcionada.')
        return null
    }
}

// Circuit breaker de auth para evitar loops en Android cuando no hay sesión
let AUTH_COOLDOWN_UNTIL = 0
const AUTH_COOLDOWN_MS = 120000 // 2 minutos
const inAuthCooldown = () => Date.now() < AUTH_COOLDOWN_UNTIL
const startAuthCooldown = () => {
    AUTH_COOLDOWN_UNTIL = Date.now() + AUTH_COOLDOWN_MS
}
export const resetAuthCooldown = () => {
    AUTH_COOLDOWN_UNTIL = 0
}
export const isAuthCooldownActive = () => inAuthCooldown()

// Throttle para logs desde getAuthToken cuando no hay sesión
let AUTH_LAST_NO_SESSION_LOG = 0

export const getAuthToken = async (code: string | null = null) => {
    try {
        // 1) Evitar tocar Identity Pool si no hay sesión: chequear usuario actual primero
        try {
            await getCurrentUser()
        } catch (noUserErr: any) {
            // Si no hay usuario y estamos en cooldown, devolver null inmediatamente
            if (inAuthCooldown()) {
                return null
            }
            // Intentar re-login silencioso con credenciales guardadas
            try {
                const username = await SecureStoreWeb.getItemAsync('username')
                const password = await SecureStoreWeb.getItemAsync('password')
                if (username && password) {
                    await signIn({ username, password })
                } else {
                    console.error('No se encontraron credenciales almacenadas')
                    startAuthCooldown()
                    return null
                }
            } catch (innerError) {
                console.error('Error al revalidar la sesión:', innerError)
                startAuthCooldown()
                return null
            }
        }

        // 2) Ya debería haber usuario actual; ahora sí pedir sesión
        const session = await fetchAuthSession()
        const authToken = session.tokens?.accessToken?.toString() || ''
        // Éxito: limpiar cooldown
        resetAuthCooldown()
        return authToken
    } catch (err: any) {
        // Sin sesión o error distinto: no insistir ni forzar logout
        const now = Date.now()
        if (now - AUTH_LAST_NO_SESSION_LOG > 120000) {
            console.error('Error en la verificación del usuario:', err)
            // Mantener UX estable (throttled)
            console.log('Error inesperado, el usuario puede continuar en la app:', err?.message || String(err))
            AUTH_LAST_NO_SESSION_LOG = now
        }
        if (err?.message && String(err.message).includes('User is disabled')) {
            console.log('El usuario está deshabilitado. Deslogueando...')
            await signOut()
        }
        return null
    }
}

export const downloadAsyncFS = async (url: string, fileUri: string) => {
    const { isConnected, isInternetReachable } = await NetInfo.fetch()
    if (isConnected && isInternetReachable) {
        const result = await downloadAsync(url, fileUri)
        return result
    } else {
        console.log('961 -- No hay conexión a internet.')
        throw new Error('downloadAsyncFS - No hay conexión a internet.')
    }
}

export const authenticateWithBiometrics = async (): Promise<boolean> => {
    try {
        const result = await LocalAuthentication.authenticateAsync({
            promptMessage: 'Autenticación Biométrica',
            fallbackLabel: 'Usar contraseña',
        })

        return result.success
    } catch (error) {
        console.error('verifyBiometricAuthentication - Error al verificar la autenticación biométrica:', error)
        return false
    }
}

export const downloadAvatarUser = async (url: string, avatar: string): Promise<string> => {
    try {
        if (!url || url === '' || !avatar || avatar === '') return

        const PATH_AVATAR = `${documentDirectory}avatars/`
        const avatarFileName = avatar.split('/').pop()
        const avatarUri = `${PATH_AVATAR}${avatarFileName}`
        const dirInfo = await getInfoAsync(PATH_AVATAR)
        if (!dirInfo.exists) {
            await makeDirectoryAsync(PATH_AVATAR, { intermediates: true })
        }

        const dirInfoFile = await getInfoAsync(avatarUri)

        if (dirInfoFile.exists) {
            console.log('El archivo ya existe:', avatarUri)
            return avatarUri
        }

        const result = await downloadAsyncFS(url, avatarUri)
        return avatarUri
    } catch (error) {
        console.error('downloadAvatarUser - Error al descargar el avatar del usuario:', error)
    }
}

export const getAvatarUser = async (avatar: string): Promise<string> => {
    try {
        const PATH_AVATAR = `${documentDirectory}avatars/`
        const avatarFileName = avatar.split('/').pop()
        const avatarUri = `${PATH_AVATAR}${avatarFileName}`
        const dirInfo = await getInfoAsync(avatarUri)
        if (dirInfo.exists) {
            return avatarUri
        } else {
            return null
        }
    } catch (error) {
        console.error('getAvatarUser - Error al obtener el avatar del usuario:', error)
        return null
    }
}

export const deleteAvatarUser = async (avatar: string): Promise<void> => {
    try {
        const PATH_AVATAR = `${documentDirectory}avatars/`
        const avatarFileName = avatar.split('/').pop()
        const avatarUri = `${PATH_AVATAR}${avatarFileName}`

        console.log('deleteAvatarUser 🚀 ~ deleteAvatarUser ~ avatarUri:', avatarUri)
        const result = await deleteAsync(avatarUri, { idempotent: true })
        console.log('deleteAvatarUser - result', result)
    } catch (error) {
        console.error('deleteAvatarUser - Error al eliminar el avatar del usuario:', error)
    }
}

/**
 * Elimina archivos de avatar locales que no estén en la lista de permitidos.
 * Mantiene sólo los nombres de archivo provistos en `keepList`.
 * Acepta claves S3 o URLs completas y extrae el nombre de archivo (tras el último '/').
 */
export const pruneAvatars = async (keepList: string[] = []): Promise<void> => {
    try {
        const PATH_AVATAR = `${documentDirectory}avatars/`
        const dir = await getInfoAsync(PATH_AVATAR)
        if (!dir.exists) return

        const toFileName = (v: string) => {
            if (!v) return ''
            try {
                // Si es URL, usar pathname
                if (v.startsWith('http://') || v.startsWith('https://')) {
                    const u = new URL(v)
                    return u.pathname.split('/').pop() || ''
                }
            } catch {}
            // S3 key u otra cadena con '/'
            const parts = v.split('/')
            return parts.pop() || ''
        }

        const keepFileNames = new Set((keepList || []).map(toFileName).filter(Boolean))
        const entries = await readDirectoryAsync(PATH_AVATAR)
        for (const entry of entries) {
            if (!keepFileNames.has(entry)) {
                try {
                    await deleteAsync(`${PATH_AVATAR}${entry}`, { idempotent: true })
                } catch (e) {
                    console.warn('pruneAvatars: no se pudo eliminar', entry, (e as any)?.message)
                }
            }
        }
    } catch (error) {
        console.error('pruneAvatars - Error al limpiar directorio de avatares:', error)
    }
}
export const getUserLogin = (email: string) => {
    const expoConfig = Constants.expoConfig || {}
    const slug = (expoConfig as any)?.slug || ''
    let userLogin = (getPrefix(slug) + email.toLowerCase()).trim()

    return userLogin
}

export const validatesNamesCampaing = () => {
    const map = {
        dots: true,
        'danone-one': true,
    }

    return map[slug] || false
}

export const validateErrorSignOut = async (error) => {
    try {
        const msg = error?.toString() || ''
        if (!msg.includes('No current user')) return

        const platform = getPlatform().OS
        console.log('validateErrorSignOut: "No current user" detected on', platform)

        // Web: este error suele ser transitorio por race conditions/Identity Pool.
        // No forzar logout; dejar que Main.jsx gestione el estado con getCurrentUser.
        if (platform === 'web') {
            console.warn('validateErrorSignOut: skipping signOut on web (transient session state)')
            return
        }

        // Nativo: verificar conectividad y realmente que no haya usuario antes de cerrar sesión
        const net = await NetInfo.fetch()
        const online = !!(net.isConnected && net.isInternetReachable)

        try {
            await getCurrentUser()
            // Si no lanza, aún hay usuario; no cerrar sesión
            console.log('validateErrorSignOut: user still present, not signing out')
            return
        } catch (e) {
            // No current user confirmado
        }

        if (online) {
            console.log('validateErrorSignOut: signing out on native after confirmed missing user')
            await signOut()
        } else {
            console.warn('validateErrorSignOut: offline, not signing out to avoid trapping user')
        }
    } catch (e) {
        console.error('validateErrorSignOut: unexpected error', e)
    }
}
const getDataErrorLogs = async () => {
    try {
        const errorLogs = await ErrorServices.getErrorLogs().catch((e) => {
            return JSON.stringify(e)
        })

        const cantPosInDB = await schedulesServices.getCountStores().catch((e) => {
            return JSON.stringify(e)
        })

        const cantFormsInDB = await schedulesServices.getCountForms().catch((e) => {
            return JSON.stringify(e)
        })

        const cantSchedulePosInDB = await schedulesServices.getCountSchedulePos().catch((e) => {
            return JSON.stringify(e)
        })

        const scheduleVersion = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION).catch((e) => {
            return JSON.stringify(e)
        })

        const checkingsPending = await schedulesServices.get_checkins_pending(FORM_SCHEDULE_STATUS.PENDING_CONNECTION).catch((e) => {
            return JSON.stringify(e)
        })

        const checkoutsPending = await schedulesServices.get_checkouts_pending(FORM_SCHEDULE_STATUS.PENDING_CONNECTION).catch((e) => {
            return JSON.stringify(e)
        })

        const formsPending = await schedulesServices
            .getFormsAnswersByStatus2(FORM_SCHEDULE_STATUS.PENDING_CONNECTION, FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE)
            .catch((e) => {
                return JSON.stringify(e)
            })

        const storage = await getStorageAvailable('MB').catch((e) => {
            return JSON.stringify(e)
        })

        const dataReturn = {
            logs: errorLogs,
            schedule_pos: cantSchedulePosInDB,
            pos: cantPosInDB,
            forms: cantFormsInDB,
            sync_checkins: checkingsPending.length,
            sync_checkouts: checkoutsPending.length,
            sync_forms: formsPending.length,
            storage: storage + ' mb',
            scheduleVersion,
        }

        return dataReturn
    } catch (error) {
        console.error('Error en getDataErrorLogs', error)
        return { error: JSON.stringify(error) }
    }
}

export const SendContact = async (subject, message, selectedChannel, userLat, userLng) => {
    try {
        let send = false
        const apiEndpoint = `${apiUrl}/send_contact`
        if (subject.trim() == '' || message.trim() == '' || selectedChannel.trim() == '') {
            return
        }

        const hasConnection = await validateConnectionNetwork()
        const isSoportChannel = selectedChannel === 'Soporte'
        const logs = isSoportChannel ? await getDataErrorLogs() : {}

        if (hasConnection) {
            const { platform, system, brand, model, app_version, name } = getDeviceInfo()
            const user = await UserServices.getUser()
            const get_schedule = await UserServices.getTableData(SCHEDULES_STORE_NAMES.SCHEDULES, 0, 10, null)
            let userLogin = ''
            if (user && user.email) userLogin = user.email
            const netInfoState = await NetInfo.fetch()
            let fecha_hoy = new Date()
            const offset = fecha_hoy.getTimezoneOffset()
            fecha_hoy = new Date(fecha_hoy.getTime() - offset * 60 * 1000) //?
            ;(logs as any).data_additional = {
                date_user: fecha_hoy,
                connection: netInfoState,
                lat: userLat ?? null,
                lng: userLng ?? null,
                schedules: get_schedule,
            }
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ''
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authToken,
                },
                body: JSON.stringify({
                    contact: {
                        channel: selectedChannel,
                        subject: subject,
                        message: message,
                        os_system: platform,
                        system: system,
                        brand: brand,
                        model: model,
                        app_version: app_version,
                        name: name,
                        user_login: userLogin,
                        logs: JSON.stringify(logs),
                    },
                }),
            })

            if (!response.ok) {
                throw new Error('Fallo al enviar el contacto')
            }
            const data = await response.json()

            if (data?.single && data.single.status == 1) {
                await ErrorServices.deleteRegistersErrorLogs()
                send = true
            }
        }
        return send
    } catch (error) {
        console.error('Error en la solicitud de envío - sendContact:', error)
    }
}

export const hasShowProgress = () => {
    const map = {
        'jti-connect': false,
        'kimberly-one': false,
    }

    return map.hasOwnProperty(slug) ? map[slug] : true
}

export const removeDuplicateLinks = (array: any[]): any[] => {
    return [...new Set(array)]
}

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

// Moved to basicUtils.ts

/**
 *
 * @param last_update_coords {Date} fecha de la ultima actualizacion de coordenadas
 * @description valida si la fecha de la ultima actualizacion de coordenadas es menor a 2 horas
 * @description si la fecha es menor a 2 horas devuelve true, sino false
 * @returns {boolean}
 */
export const validateUpdateCoordsTime = (last_update_coords: Date): boolean => {
    try {
        //* comento para que siempre valide
        // const currentDate = new Date()

        // const timeMaxUpdate = 2 // horas

        // const timeDifference = (currentDate.getTime() - new Date(last_update_coords).getTime()) / (1000 * 60 * 60)

        // return timeDifference <= timeMaxUpdate

        return true
    } catch (error) {
        console.error('validateUpdateCoordsTime => ', error)
        return true
    }
}

export const openExternalLink = (url: string) => {
    const isValidUrl = /^https?:\/\/[\w.-]+\.[a-z]{2,}.*$/.test(url)

    if (isValidUrl) {
        Linking.openURL(url).catch((err) => console.error('Error al abrir el enlace:', err))
    } else {
        console.error('URL inválida:', url)
    }
}

export const isValidDateString = (value: any): boolean => {
    if (value == null || value == undefined) return false
    if (typeof value !== 'string') return false
    if (value.trim() === '') return false

    const date = new Date(value)
    return !isNaN(date.getTime())
}

/**
 * @description si el valor es invalido, devuelve true
 * @param value
 * @returns {boolean}
 */
export const isInvalidData = (value: any): boolean => {
    if (
        value === null ||
        value === undefined ||
        (typeof value === 'string' && value.trim() === '') ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
    ) {
        return true
    }

    return false
}

/**
 * Valida si un valor es "vacío" considerando múltiples casos edge:
 * - null, undefined
 * - strings vacíos ("")
 * - strings "null", "undefined" (como strings literales)
 * - arrays vacíos []
 * - objetos vacíos {}
 * 
 * @param {*} value - Valor a validar
 * @returns {boolean} - true si el valor está vacío, false si tiene contenido válido
 */
export const isEmpty = (value: any): boolean => {
    // null o undefined
    if (value === null || value === undefined) {
        return true
    }

    // String vacío o strings literales "null"/"undefined"
    if (typeof value === 'string') {
        const trimmed = value.trim().toLowerCase()
        return trimmed === '' || trimmed === 'null' || trimmed === 'undefined'
    }

    // Array vacío
    if (Array.isArray(value)) {
        return value.length === 0
    }

    // Objeto vacío
    if (typeof value === 'object') {
        return Object.keys(value).length === 0
    }

    // Cualquier otro caso (números, booleanos, etc.) se considera válido
    return false
}

/**
 * Valida si un valor tiene contenido válido (inverso de isEmpty)
 * @param {*} value - Valor a validar
 * @returns {boolean} - true si tiene contenido válido
 */
export const hasValue = (value: any): boolean => {
    return !isEmpty(value)
}

export const textTransformUpperCase = (string: string): string => {
    if (string == null || string == undefined || string.trim() == '' || !string) {
        return ''
    }

    return string.toUpperCase()
}

// Moved to basicUtils.ts
/**
 * @description Devuelve string con la fecha y hora actual en formato ISO 8601 con hora local
 * @returns {String} 2025-05-29T23:14:08.123
 */
export const getLocalISOString = (): string => {
    const now = new Date()

    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    const seconds = String(now.getSeconds()).padStart(2, '0')
    const millis = String(now.getMilliseconds()).padStart(3, '0')

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${millis}`
}

/**
 * @description Devuelve string con la fecha y hora actual en formato ISO 8601 con hora local y el offset de la zona horaria
 * @returns {String} 2025-05-29T23:14:08.123-06:00
 */
export const getLocalISOStringWithOffset = (): string => {
    const now = new Date()

    const tzOffsetMin = now.getTimezoneOffset()
    const sign = tzOffsetMin <= 0 ? '+' : '-'
    const absOffset = Math.abs(tzOffsetMin)
    const offsetHours = String(Math.floor(absOffset / 60)).padStart(2, '0')
    const offsetMinutes = String(absOffset % 60).padStart(2, '0')

    const isoLocal = getLocalISOString()
    return `${isoLocal}${sign}${offsetHours}:${offsetMinutes}`
}

export const shareDatabaseLocalSqlite = async () => {
    try {
        const dbPath = `${documentDirectory}SQLite/myDB`
        const exportPath = `${documentDirectory}myDB`
        await copyAsync({
            from: dbPath,
            to: exportPath,
        })
        await shareAsync(exportPath)
    } catch (error) {
        console.error('Error exportando la base de datos:', error)
    }
}

// Moved to basicUtils.ts

export const isEntornoTesting = () => {
    return apiUrl.includes(TEST) || slug == CLIENTS_SLUGS.DOTS_II
}

// Moved to basicUtils.ts

export const findAssetsInDirectory = async (directoryPath) => {
    try {
        const files = await readDirectoryAsync(directoryPath)
        console.log('Archivos encontrados en el directorio:', files)
        return files.filter((file) => file.endsWith('.json'))
    } catch (error) {
        // console.error('Error al buscar assets en el directorio:', error)
        return []
    }
}

export const downloadZip = async (name: string, url: string) => {
    if (!url || url === '') {
        console.log('URL no válida.')
        return null
    }
    const directoryUri = name && name != '' ? `${documentDirectory}zip/${name}/` : `${documentDirectory}zip/`

    const fileUri = `${directoryUri}downloaded.zip`

    const pathDownloaded = name && name != '' ? `${documentDirectory}unzipped/${name}/` : `${documentDirectory}unzipped/`

    try {
        // Descargar el archivo ZIP
        const dirInfo = await getInfoAsync(directoryUri)

        if (!dirInfo.exists) {
            // si no existe el directorio, lo creamos
            await makeDirectoryAsync(directoryUri, { intermediates: true })
            console.log('Directorio creado:', directoryUri)
        }

        // Verifico si existe el archivo zip y lo elimino
        await verifyAndDeleteZip(fileUri)

        const { uri } = await downloadAsync(url, fileUri)
        // console.log('241 --- 🚀 ~ downloadAndUnzipAllFiles ~ uri:', uri)

        // Leer el contenido del archivo ZIP como binario

        console.log('Descarga completada en:', pathDownloaded)
        return pathDownloaded
    } catch (error) {
        console.log('Error al descargar el archivo ZIP:', error)
        return null
    }
}
export const unZip = async (zipFilePath: string, destinationPath: string, willUnZip = null) => {
    const pathDownloaded =
        destinationPath && destinationPath != '' ? `${documentDirectory}unzipped/${destinationPath}/` : `${documentDirectory}unzipped/`

    try {
        const dirInfo = await getInfoAsync(zipFilePath)

        if (!dirInfo.exists) {
            console.log('El archivo ZIP no existe:', zipFilePath)
            return null
        }
        willUnZip != null && willUnZip()

        const fileContents = await readAsStringAsync(zipFilePath, {
            encoding: 'base64',
        })
        const zip = new JSZip()
        const content = await zip.loadAsync(fileContents, { base64: true })
        let targetPath = null

        let fileNameFather = zipFilePath.substring(zipFilePath.lastIndexOf('/') + 1, zipFilePath.lastIndexOf('.zip'))

        // para sacar el 00_id
        if (fileNameFather.includes('_')) {
            const fileNameFatherSplit = fileNameFather.split('_')
            fileNameFather = fileNameFatherSplit[1]
        }

        // Extraer archivos a la carpeta de destino
        for (let filename of Object.keys(content.files)) {
            // Filtrar archivos __MACOSX. Metadatos que macOS incluye en los archivos ZIP
            if (filename.startsWith('__MACOSX/')) {
                continue
            }

            // sacar el nombre del archivo padre
            const relativePath = filename.replace(`${fileNameFather}/`, '')

            let file = content.files[filename]

            if (!file.dir) {
                let fileData = await file.async('base64')
                targetPath = `${pathDownloaded}${relativePath}`

                // Crear directorio de destino si es necesario
                const targetDir = targetPath.substring(0, targetPath.lastIndexOf('/'))
                await makeDirectoryAsync(targetDir, { intermediates: true })

                // Escribir el archivo descomprimido en el sistema de archivos
                await writeAsStringAsync(targetPath, fileData, {
                    encoding: 'base64',
                })
            }
        }
        // console.log('Descompresión completada en:', pathDownloaded)
        await deleteZipFolder(zipFilePath)
        return pathDownloaded
    } catch (error) {
        console.log('Error al descomprimir el archivo ZIP:', error)
    }
}
export async function getImageSize(uri: string) {
    try {
        // Usar manipulateAsync directamente (expo-image-manipulator v11+)
        const result = await manipulateAsync(
            uri,
            [], // sin acciones
        )
        // console.log('getImageSize - result:', result)
        return { width: result.width, height: result.height }
    } catch (error) {
        console.error('Error obteniendo dimensiones:', error)
        return { width: 0, height: 0 }
    }
}

/**
 * @description Realiza un parseo profundo de JSON en caso de que el valor sea una cadena JSON anidada.
 * @param value valor a parsear.
 * @param fallback valor a retornar en caso de error o valor inválido. (default null)
 * @param maxDepth indica la profundidad máxima de parseo para evitar bucles infinitos. (default 5)
 * @returns 
 */
export const deepJSONParse = (value: any, fallback = null, maxDepth = 5) => {
    if (typeof value !== 'string' || maxDepth <= 0) {
        return value !== undefined && value !== null ? value : fallback
    }
    try {
        const parsed = JSON.parse(value)
        
        if (typeof parsed === 'string') {
            return deepJSONParse(parsed, fallback, maxDepth - 1)
        }
        return parsed
    } catch (error) {
        console.warn('[deepJSONParse] Parse error, returning fallback:', error.message)
        return value !== '' ? value : fallback
    }
}

/**
 * Elimina comillas dobles al inicio y final de un string si existen
 * Maneja casos de strings "envueltos" múltiples veces
 * @param value - String a limpiar
 * @returns String sin comillas extras
 */
export const cleanDoubleQuotedString = (value: string): string => {
    if (!value || typeof value !== 'string') {
        return value
    }

    let cleaned = value.trim()
    
    // Remover comillas dobles repetidas hasta que no queden más
    while (
        (cleaned.startsWith('"') && cleaned.endsWith('"')) ||
        (cleaned.startsWith("'") && cleaned.endsWith("'"))
    ) {
        cleaned = cleaned.slice(1, -1).trim()
    }

    return cleaned
}
